/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'tbody',
};

const TableBody = (props) => {
    const classNames = [
        'c-table__body',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

TableBody.propTypes = propTypes;

TableBody.defaultProps = defaultProps;

export default TableBody;
